<template>
  <div class="d-flex align-items-center">
    <i class="far fa-circle-notch spinner"></i>
    <span v-if="message" class="ml-1">{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: "" },
  },
};
</script>
